import api from '../api';
const jsRoutes = require('routes.js.erb');

const PAGE_SIZE = 30;

const getAllCollections = function({ commit }) {
  return getCollectionPage(1).then(function(response) {
    const totalItems = response.data.total_count || 0;
    if (totalItems == 0) return;

    const pages = Math.ceil(totalItems / PAGE_SIZE);

    commit("setCollections", response.data.collections);
    for (let i = 2; i < pages; i++) {
      getCollectionPage(i).then(function(collections) {
        commit("addCollections", collections);
      });
    }
  });
};

const getCollectionPage = function(page) {
  return api.get(jsRoutes.api_v5_collections_path({ per_page: PAGE_SIZE, page: page })).then(function(response) {
    return response.data;
  });
};

export { getAllCollections };